export class CollectionFilters extends HTMLElement {
  facetButton;
  clearFilterButton;
  resetFilterButton;
  sortByButton;
  sortByButtonDesk;
  _abortController;
  _loadingBar;

  connectedCallback() {
    this._abortController = new AbortController();

    this.clearFilterButton = this.querySelectorAll('[data-action="clear-filter"]');
    this.resetFilterButton = document.querySelector('[data-action="reset-filter"]');
    this.seeAll = document.querySelector('[data-action="see-all"]');

    this.sortByButton = this.querySelector('#sort-by-filter');
    this.sortByButtonDesk = document.querySelector('#sort-by-filter-desk');
    this.facetButton = this.querySelectorAll('[name^="filter."]:not(.price-search)');
    this.dataEventGtm = document.querySelectorAll('[data-event-gtm]');
    this._loadingBar = document.querySelector('.loading-bar');

    if (this.sortByButton) {
      this.sortByButton.addEventListener('change', this._collectionSortBySelect.bind(this), { signal: this._abortController.signal });
    }
    if (this.sortByButtonDesk) {
      this.sortByButtonDesk.addEventListener('change', this._collectionSortBySelect.bind(this), { signal: this._abortController.signal });
    }

    if (this.resetFilterButton) {
      this.resetFilterButton.addEventListener('click', this._clearFilter.bind(this), { signal: this._abortController.signal });
    }

    Array.from(this.clearFilterButton).forEach((button) => {
      button.addEventListener('click', this._clearFilter.bind(this), { signal: this._abortController.signal });
    })

    Array.from(this.dataEventGtm).forEach((button) => {
      button.addEventListener('click', this._pushGtmData.bind(this), { signal: this._abortController.signal });
    })

    Array.from(this.facetButton).forEach((button) => {
      button.addEventListener('change', this._collectionFilter.bind(this), { signal: this._abortController.signal });
    })

  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  /**
  * Push GTM Data
  */

  _pushGtmData(event) {
    let object = {};
    if (event.target.getAttribute('data-event-parameter')) {
      object = {
        event: event.target.getAttribute('data-event'),
        event_parameter: event.target.getAttribute('data-event-parameter')
      };
    } else {
      object = {
        event: event.target.getAttribute('data-event')
      };
    }

    if (window.shop.gtmV2Active) {
      dataLayer = window.dataLayer || [];
      dataLayer.push(object);
    } else {
      console.log('dataLayer', object);
    }
  }


  /**
   * Filter collection
   */
  _collectionFilter(event) {
    if (event) event.preventDefault();

    let formData = new FormData(document.querySelector('#collection-filter-form'));

    let searchParamsAsString = new URLSearchParams(formData);

    if (searchParamsAsString.get("filter.v.price.gte") === '' && searchParamsAsString.get("filter.v.price.lte") === '') {
      searchParamsAsString.delete("filter.v.price.gte");
      searchParamsAsString.delete("filter.v.price.lte");
    }
    if (searchParamsAsString.get("q") === '') {
      searchParamsAsString.delete("q");
    }
    if (searchParamsAsString.get("page") === 'all') {
      searchParamsAsString.delete("page");
    }
    searchParamsAsString = searchParamsAsString.toString();

    let url = (searchParamsAsString != '') ? window.location.pathname + '?' + searchParamsAsString : window.location.pathname;

    this._fetchSectionHtml(url);
  }


  /**
   * Clear filter
   */
  _clearFilter(event) {
    if (event) event.preventDefault();

    let url = event.target.getAttribute('href');

    if (window.matchMedia('(max-width: 981px)').matches) {
      document.querySelector('#content_filter').setAttribute('aria-expanded', 'false');
    }

    this._fetchSectionHtml(url, true);
  }

  /**
   * Sort by
   */
  _collectionSortBySelect(e) {
    if (e) e.preventDefault();

    let sortBy = e.currentTarget;
    let valueSortBy = sortBy.options[sortBy.selectedIndex].value;

    let object = {
      event: "selectOrderBy",
      event_parameter: sortBy.options[sortBy.selectedIndex].getAttribute('data-gtm-value')
    };

    if (window.shop.gtmV2Active) {
      dataLayer = window.dataLayer || [];
      dataLayer.push(object);
    } else {
      //console.log('dataLayer', object);
    }

    this._fetchSectionHtml(valueSortBy, true);
  }

  /**
   * Call to section
   */
  _fetchSectionHtml(url, clear, scrollTop) {
    // Add URL params
    let newUrl = new URL(window.location.origin + url);
    newUrl.searchParams.set('section_id', 'collection-page');
    window.history.replaceState({ path: url }, '', url);

    this._loadingBar = document.querySelector('.loading-bar');

    this._showLoader();

    fetch(newUrl.href)
      .then((response) => response.text())
      .then((html) => {

        this._loadingBar.style.width = '100%';
        this._loadingBar.addEventListener('transitionend', this._hideLoader.bind(this));

        let collectionContent = document.querySelector('#shopify-section-collection-page');
        let div = document.createElement('div');
        div.innerHTML = html;

        // Open dropdowns even when there are no active filters
        document.querySelectorAll('collapse-element').forEach(function (item) {
          let openFilter = item.querySelector('.collection__filter-content-button');
          let see_more = item.querySelector('.filter_see-more');
          let newButton = "";
          let isExpandedFilters = "";
          if (openFilter) {
            newButton = div.querySelector('[aria-controls="' + openFilter.getAttribute('aria-controls') + '"]');
            isExpandedFilters = openFilter.getAttribute('aria-expanded') === 'true';
          }

          if (isExpandedFilters) {
            if (newButton) {
              newButton.setAttribute('aria-expanded', 'true');
              newButton.nextElementSibling.classList.add('collapse-opened');
            }
          }
          // Updated aria-expanded
          if (window.matchMedia('(max-width: 981px)').matches) {
            if (isExpandedFilters) {
              if (see_more) {
                let isExpandedSeeMore = see_more.getAttribute('aria-expanded') === 'true';
                let newCollapseContent = div.querySelector('#' + openFilter.getAttribute('aria-controls'));
                if (isExpandedSeeMore) {
                  if (newCollapseContent.querySelector('.filter_see-more')) {
                    newCollapseContent.querySelector('.filter_see-more').setAttribute('aria-expanded', 'true');
                  }
                }
              }
            }
          }

        })

        // Open or close the popin as needed
        if (window.matchMedia('(max-width: 981px)').matches) {
          let panelFilterOpen = document.querySelector('#content_filter');
          if (panelFilterOpen && !clear) {
            div.querySelector('#content_filter').setAttribute('aria-expanded', 'true');
          }
        }

        if (collectionContent) {
          collectionContent.innerHTML = div.innerHTML;
        }

        let sidebarContainer = document.querySelector("#collection-filter-form");
        if (window.matchMedia('(max-width: 981px)').matches) {
          let panelFilterOpen = document.querySelector('#content_filter');
          if (panelFilterOpen && !clear) {
            if (sidebarContainer) {
              sidebarContainer.style.zIndex = "30";
            }
          } else {
            // Remove the auto overflow if you don't open the popin
            let body = document.querySelector("body");
            body.style.overflow = "auto";
            if (sidebarContainer) {
              sidebarContainer.style.zIndex = "29";
            }
          }
        }

        // Open the dropdowns at the right size depending on whether the see-more is active or not
        if (window.matchMedia('(max-width: 981px)').matches) {
          document.querySelectorAll('collapse-element').forEach(function (item) {
            let openFilter = item.querySelector('.collection__filter-content-button');
            if (openFilter) {
              let see_more = item.querySelector('.filter_see-more');
              let see_more_hidden = item.querySelector('.filter_see-more.hidden');
              let isExpandedFilters = openFilter.getAttribute('aria-expanded') === 'true';
              let collapseContent = item.querySelector('#' + openFilter.getAttribute('aria-controls'));
              let collapseContentList = item.querySelector('.filter-group__list');
              if (isExpandedFilters) {
                if (see_more_hidden) {
                  if (collapseContent && collapseContentList) {
                    collapseContent.style.height = (collapseContentList.scrollHeight + 15) + 'px';
                  }
                } else {
                  if (see_more) {
                    let isExpandedSeeMore = see_more.getAttribute('aria-expanded') === 'true';
                    let heightContent = see_more.getAttribute('close-height');
                    if (isExpandedSeeMore) {
                      collapseContent.style.height = (collapseContentList.scrollHeight + 15) + 'px';
                    } else {
                      collapseContent.style.height = heightContent + 'px';
                    }
                  } else {
                    if (collapseContent && collapseContentList) {
                      if ((openFilter.getAttribute('aria-controls') === "filters-marques") || (openFilter.getAttribute('aria-controls') === "filters-brands")) {
                        collapseContent.style.height = (collapseContentList.scrollHeight + 78) + 'px';
                      } else {
                        collapseContent.style.height = (collapseContentList.scrollHeight + 15) + 'px';
                      }
                    }
                  }
                }
              }
            }
          })

        }

        // scroll to products
        if (scrollTop) {
          window.scrollTo({
            top: scrollTop,
            left: 0
          });
        } else {
          let top = $('#product-results').offset().top;
          let airportMenu = document.querySelector('.airport-menu');
          if (airportMenu) {
            top = $('#product-results').offset().top - (airportMenu.clientHeight + 10);
          }
          if (window.matchMedia('(max-width: 981px)').matches) {
            top = $('#product-results').offset().top - 100;
          }

          $('html, body').animate({
            scrollTop: top
          }, 250);
        }

      })
      .catch((error) => {
        // Request failed
        console.error(error);
      });
  }

  _showLoader() {
    this._loadingBar.classList.add('loading-bar--visible');
    this._loadingBar.style.width = '60%';
  }

  _hideLoader() {
    this._loadingBar.classList.remove('loading-bar--visible');
    this._loadingBar.style.width = '0%';
  }

}

export class SearchFilters extends HTMLElement {
  searchInput;
  _abortController;
  algoliaClient;

  connectedCallback() {
    this._abortController = new AbortController();
    this.algoliaClient = algoliasearch(window.shop.algolia.id, window.shop.algolia.search_key);

    this.searchInput = this.querySelector('input[name="q"]');
    this.searchInput.addEventListener('input', this._doAlgoliaSearch.bind(this), { signal: this._abortController.signal });

    /** Launching the function on page load **/
    if (this.searchInput.value !== "") {
      this._doAlgoliaSearch();
    }
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  /**
  * Search brands filters
  */
  _doAlgoliaSearch() {

    /** Change url when search input is empty **/
    if (this.searchInput.value === "") {
      let currentUrl = document.location.href;
      if (currentUrl.includes('q=')) {
        let currentUrl_1 = currentUrl.split('q=');
        let currentUrl_2 = currentUrl_1[1].split('&');
        let newUrl = currentUrl_1[0] + 'q=&' + currentUrl_2[1];
        window.history.replaceState({ path: newUrl }, '', newUrl);
      }
    }

    let queries = [{
      indexName: window.shop.algolia.index + 'collections',
      query: this.searchInput.value,
      params: {
        restrictSearchableAttributes: ['title'],
        filters: 'template_suffix:marque'
      }
    }];

    let that = this;
    this.algoliaClient.search(queries, function (err, content) {
      let results = content['results'];
      that._searchBrands(results[0].hits);
    });
  }

  _searchBrands(data) {
    let element = this.getAttribute('data-element');
    let collapseContent = document.querySelector('#filters-' + element + '');
    let collapseContentList = this.querySelector('.filter-group__list');
    let searchValue = this.searchInput.value;

    if (searchValue !== "") {
      Array.from(this.querySelectorAll('[data-filter="' + element + '"]')).forEach((item) => {
        item.classList.add('hidden-brand');
      });

      let that = this;
      data.forEach(function (item) {
        let displayElement = that.querySelector('[data-handle="' + item['handle'] + '"]');
        if (displayElement) {
          displayElement.classList.remove('hidden-brand');
        }
      });
    } else {
      Array.from(this.querySelectorAll('[data-filter="' + element + '"]')).forEach((item) => {
        item.classList.remove('hidden-brand');
      });
    }

    /* Dropdown size change  */
    if (collapseContent && collapseContentList) {
      if (window.matchMedia('(max-width: 981px)').matches) {
        collapseContent.style.height = (collapseContentList.scrollHeight + 78) + 'px';
      } else {
        if (collapseContentList.scrollHeight < 358) {
          collapseContent.style.height = (collapseContentList.scrollHeight + 78) + 'px';
          collapseContentList.classList.remove('gradient');
        } else {
          collapseContent.style.height = '358px';
          collapseContentList.classList.add('gradient');
        }
      }
    }

  }

}

export class t2sPagination extends HTMLElement {
  _paginateButton;
  _loadingBar;
  _abortController;

  connectedCallback() {
    this._abortController = new AbortController();
    this._paginateButton = this.querySelectorAll('[data-action="t2s-pagination"]');
    this._loadingBar = document.querySelector('.loading-bar');

    Array.from(this._paginateButton).forEach(button => button.addEventListener('click', this._handlePaginationButton.bind(this), { signal: this._abortController.signal }));

    document.addEventListener('t2s-page:change', (event) => this._paginateT2sProducts(event.detail.page));
  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  _handlePaginationButton(event) {
    if (event) event.preventDefault();

    this._loadingBar.addEventListener('transitionend', this._hideLoader.bind(this));
    // get page index
    let pageIndex = event.currentTarget.getAttribute('href').split('#')[1];

    // car ajax template to display products
    this._paginateT2sProducts(pageIndex);
  }

  async _paginateT2sProducts(index) {
    this._showLoader();

    // get current URL
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    // rewrite URL to add page=X query param
    params.set('page', index);

    let newURL = url.pathname + '?' + params.toString();
    window.history.replaceState({ path: newURL }, '', newURL);

    // remove page param because we have the 1000 products pagination
    params.delete('page');
    params.append('view', 't2s-paginate');
    params.append('id', index);
    let fetchURL = url.pathname + '?' + params.toString();

    await fetch(fetchURL)
      .then((response) => response.text())
      .then(result => {
        document.querySelector('#product-results-container').innerHTML = result;
        this._loadingBar.style.width = '100%';

        //this._sendT2STracking(parseInt(index));

        // reload GTM
        let productHandles = [];
        document.querySelectorAll('.product-list__grid-cell').forEach((item) => {
          if (item.getAttribute('data-gtm-handle')) {
            productHandles.push('handle:' + item.getAttribute('data-gtm-handle'));
          }
        })

        fetch(`/search?view=product-gtm&type=product&q=${productHandles.join(' OR ')}`)
          .then((response) => response.text())
          .then(result => {
            document.dispatchEvent(new CustomEvent('gtm.customEvent', {
              bubbles: true,
              detail: '{"event": "productImpression","ecommerce": { "impressions":' + result + '}}'
            }));
          });

        this._scrollToList();
        this._initT2s();
      })

  }

  _initT2s() {

    document.documentElement.dispatchEvent(new CustomEvent('t2s:productsAppended', {
      bubbles: true
    }));

  }

  _scrollToList() {
    if (window.matchMedia('(min-width: 1024px').matches) {
      // do nothing during the loading of loyalty points
      if (window.shop.template != "collection.vp-loyalty") {
        $('html, body').animate({
          scrollTop: $('#product-results').offset().top - 8
        }, 250);
      }
      /*if (window.shop.template === "collection.marque") {
        $('html, body').animate({
          scrollTop: $('#product-results').offset().top - 70
        }, 250);
      } else if (window.shop.template === "collection.vp-loyalty") {
        // do nothing during the loading of loyalty points
      } else {
        $('html, body').animate({
          scrollTop: $('#product-results').offset().top - 70
        }, 250);
      }*/
    } else {
      let airportMenu = document.querySelector('.airport-menu');
      if (airportMenu) {
        $('html, body').animate({
          scrollTop: $('#product-results').offset().top - 95
        }, 250);
      } else {
        $('html, body').animate({
          scrollTop: $('#product-results').offset().top - 38
        }, 250);
      }
    }
  }

  _showLoader() {
    this._loadingBar.classList.add('loading-bar--visible');
    this._loadingBar.style.width = '60%';
  }

  _hideLoader() {
    this._loadingBar.classList.remove('loading-bar--visible');
    this._loadingBar.style.width = '0%';
  }

}

export class CollectionContainer extends HTMLElement {
  _abortController;
  isT2sActive;

  connectedCallback() {
    this._abortController = new AbortController();
    this.isT2sActive = this.getAttribute('data-t2s');

    if (this.isT2sActive === 'true') {
      this._initT2s();
    }

  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  _initT2s() {

    // Si la pagination est activée sur un tri en T2S, il faut l'intercepter et relancer le fetch pour récuperer les produits T2S
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get('page');

    if (parseInt(page) > 1) {
      document.documentElement.dispatchEvent(new CustomEvent('t2s-page:change', {
        bubbles: true,
        detail: {
          page: page
        }
      }));
    }


    /*if (parseInt(page) > 1) {
      this._paginateT2sProducts(page);
    } else {
      this._sendT2STracking('send tracking 1');
    }*/

  }

  _sendT2STracking(page) {
    //console.log('_sendT2STracking', page);
  }

}

export class SeeAll extends CollectionFilters {
  seeAll;
  _abortController;

  connectedCallback() {
    this._abortController = new AbortController();

    this.seeAll = this.querySelector('[data-action="see-all"]');

    if (this.seeAll) {
      this.seeAll.addEventListener('click', this._seeAll.bind(this), { signal: this._abortController.signal });
    }

  }

  disconnectedCallback() {
    this._abortController.abort();
  }

  /**
  * Sort by
  */
  _seeAll(e) {
    if (e) e.preventDefault();

    let valueSeeAll = this.getAttribute('data-url');

    let object = {
      event: "clickDisplayAll",
    };

    if (window.shop.gtmV2Active) {
      dataLayer = window.dataLayer || [];
      dataLayer.push(object);
    } else {
      //console.log('dataLayer', object);
    }

    this._fetchSectionHtml(valueSeeAll, true, window.scrollY);
  }

}

if (!window.customElements.get('collection-filters')) {
  window.customElements.define('collection-filters', CollectionFilters);
}

if (!window.customElements.get('search-filters')) {
  window.customElements.define('search-filters', SearchFilters);
}

if (!window.customElements.get('collection-t2s-pagination')) {
  window.customElements.define('collection-t2s-pagination', t2sPagination);
}

if (!window.customElements.get('collection-container')) {
  window.customElements.define('collection-container', CollectionContainer);
}

if (!window.customElements.get('see-all')) {
  window.customElements.define('see-all', SeeAll);
}